import { useState, useMemo } from "react";
import {
  FileText,
  MapPinCheck,
  DollarSign,
  House,
  Truck,
  Wallet,
  ScrollText,
} from "lucide-react";
import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

// Икон: public доторх зургийг ачаална, байхгүй/алдаатай бол lucide икон руу унана.
// public/services/ дотор нэрийг нь тааруулж зураг (png/svg) хийхэд автоматаар солигдоно.
const ServiceIcon = ({ src, Icon }) => {
  const [err, setErr] = useState(false);
  if (src && !err) {
    return (
      <img
        src={src}
        alt=""
        className="w-16 h-16 object-contain"
        onError={() => setErr(true)}
      />
    );
  }
  return (
    <Icon className="w-8 h-8 text-gray-700 group-hover:text-white transition-colors" />
  );
};

// Үйлчилгээний нөхцөл (popup-д харагдана)
const TERMS_TEXT = `1. ЕРӨНХИЙ НӨХЦӨЛ

1.1. Энэхүү үйлчилгээний нөхцөл нь ХҮЛЭГ КАРГО (цаашид "Карго" гэх)-ын ачаа тээвэр, зуучлал, хадгалалт болон түүнтэй холбоотой бүх төрлийн харилцааг зохицуулна.

1.2. Карго нь Бүгд Найрамдах Хятад Ард Улсын нутаг дэвсгэрээс хэрэглэгчийн захиалсан бараа бүтээгдэхүүнийг хүлээн авч, Эрээн хот дахь агуулахад төвлөрүүлэн Монгол Улсын хил хүртэл болон цааш хэрэглэгчид хүргэх тээвэр зуучлалын үйлчилгээ үзүүлнэ.

1.3. Карго нь барааны үйлдвэрлэгч, худалдагч, эсвэл нийлүүлэгч биш бөгөөд хэрэглэгчийн захиалсан барааны чанар, үйлдвэрийн доголдол, анхны эвдрэл гэмтэлд хариуцлага хүлээхгүй.

1.4. Хэрэглэгч нь энэхүү үйлчилгээний нөхцөлийг хүлээн зөвшөөрсөн тохиолдолд үйлчилгээ авах эрх үүснэ.

2. ХЭРЭГЛЭГЧИЙН ЭРХ, ҮҮРЭГ

2.1. Хэрэглэгч нь дараах мэдээллийг үнэн зөв өгнө: захиалгын линк/трэк код, хүлээн авагчийн мэдээлэл, холбоо барих утас, хаяг.

2.2. Хэрэглэгч нь хориотой болон эрсдэлтэй бараа захиалахгүй байх үүрэгтэй.

2.3. Хэрэглэгч нь "Хэврэг бараа"-ны эрсдэлийг бүрэн ойлгож, захиалга хийхдээ өөрөө хариуцлага хүлээнэ.

3. КАРГОНЫ ЭРХ, ҮҮРЭГ

3.1. Карго нь барааг Эрээн агуулахад хүлээн авч, бүртгэн, стандарт нөхцөлөөр хадгалж, тээвэрлэлтэд шилжүүлнэ.

3.2. Карго нь өөрийн буруутай үйлдэл (буруу илгээх, алдах, агуулахад гэмтээх)-ээс үүдэлтэй хохирлыг хариуцна.

3.3. Карго нь дараах нөхцөлд хариуцлага хүлээхгүй: барааны үйлдвэрийн доголдол; дотор гэмтэлтэй боловч гадна сав баглаа гэмтээгүй тохиолдол; тээврийн явцад үүсэх доргилт, чичиргээ, температур, чийгшлийн нөлөө (хэврэг бараа); хэрэглэгчийн буруу мэдээлэл, буруу захиалга.

3.4. Шил, шаазан, толь, дэлгэц, LCD, электрон нарийн төхөөрөмж зэрэг "хэврэг бараа" нь өндөр эрсдэлтэй ангилалд хамаарна.

3.5. Карго нь хэврэг барааны тээвэрлэлтийн явцад үүсч болзошгүй дотор гэмтэл, хагарал, ажиллагааны доголдолд хариуцлага хүлээхгүй.

4. ХОРИОТОЙ БАРАА

4.1. Каргогоор тээвэрлэхэд тохиромжгүй ачааг (амархан хагарч эвдрэх зүйлс, доргилтонд гэмтэх технологийн бүтээгдэхүүн, бүх төрлийн хүнс) Эрээн агуулахад хүлээж авахгүй.

4.2. Монгол улсын хуулиар гаалиар нэвтрүүлэхийг хориглосон бараа (согтууруулах ундаа, тамхи, эм, тэсэрч дэлбэрэх бодис, мансууруулах бодис, галт зэвсэг, шатахуун г.м)-г тээвэрлэхгүй.

4.3. Тусгай зөвшөөрлийн лиценз шаардсан бараанд хэрэглэгч лицензтэй бол КАРГО Монгол улсын гааль хүртэлх гүйцэтгэлийг хийж болно.

5. ТЭЭВЭРЛЭЛТИЙН ХУГАЦАА

5.1. Бараа Эрээн агуулахад хүргэгдэн Монгол руу ачигдсанаас хойш ердийн нөхцөлд 2-7 хоног дотор УБ хотод ирнэ. Бүх нийтийн баяр ёслол, давагдашгүй хүчин зүйл (гал, газар хөдлөлт, цаг агаар, хорио цээр г.м) үүсвэл хугацаа сунгагдаж болно.

6. МАРГААН ШИЙДВЭРЛЭХ ЖУРАМ

6.1. Маргаан үүсвэл хэрэглэгч дараах баримтыг бүрдүүлнэ: бараа задалж буй бичлэг (unboxing video), гадна сав баглааны зураг, гэмтлийн зураг/видео.

6.2. Карго нь маргааныг каргогийн буруутай үйлдэл нотлогдсон эсэх, гадна сав баглааны бүрэн бүтэн байдал, Хятад нийлүүлэгчийн хариуцлагын хүрээгээр шийдвэрлэнэ.

6.3. Гадна сав баглаа бүрэн, гэмтэлгүй ирсэн боловч дотор эвдрэл илэрвэл энэ нь үйлдвэрлэгчийн доголдол эсвэл тээврийн эрсдэлд хамаарах бөгөөд Карго хариуцлага хүлээхгүй.

7. БУСАД

7.1. Карго нь үйлчилгээний нөхцөлийг урьдчилан мэдэгдэлгүйгээр шинэчлэх эрхтэй.

7.2. Хэрэглэгч нь үйлчилгээ ашигласнаар энэхүү нөхцөлийг бүрэн хүлээн зөвшөөрсөнд тооцогдоно.`;

const services = [
  {
    icon: FileText,
    img: "/services/instruction.png",
    label: "Заавар сургалт",
    description: "Захиалга хийх заавар",
    color: "text-primary",
  },
  {
    icon: MapPinCheck,
    img: "/services/address.png",
    label: "Хаяг холбох",
    description: "Хятад хаяг авах",
    color: "text-yellow-600",
  },
  {
    icon: DollarSign,
    img: "/services/price.png",
    label: "Үнийн мэдээлэл",
    description: "Хүргэлтийн үнэ",
    color: "text-green-600",
  },
  {
    icon: House,
    img: "/services/branch.png",
    label: "Салбарын мэдээл",
    description: "Агуулахын хаяг",
    color: "text-blue-600",
  },
  {
    icon: ScrollText,
    img: "/services/terms.png",
    label: "Үйлчилгээний нөхцөл",
    description: "Үйлчилгээний нөхцөл",
    color: "text-gray-600",
  },
];

const ServicesSection = ({
  price = [],
  branch = [],
  connect = [],
  training = [],
  delivery = [],
  exchange = [],
}) => {
  const [openIndex, setOpenIndex] = useState(null);

  // ---------------- MAP VALUES ----------------
  const priceMap = useMemo(() => {
    const map = {};
    price.forEach((p) => (map[p.id] = p.value));
    return map;
  }, [price]);

  const deliveryMap = useMemo(() => {
    const map = {};
    delivery.forEach((p) => (map[p.id] = p.value));
    return map;
  }, [delivery]);

  const exchangeMap = useMemo(() => {
    const map = {};
    exchange.forEach((t) => {
      map[t.id] = { name: t.exchange, value: t.value };
    });
    return map;
  }, [exchange]);

  const handleOpen = (index) => setOpenIndex(index);
  const handleClose = () => setOpenIndex(null);

  // ---------------- POPUP CONTENT ----------------
  const getDescriptionHtml = (service) => {
    if (service.label === "Үйлчилгээний нөхцөл") {
      return `<div style="white-space:pre-line; line-height:1.65; font-size:13.5px; color:#374151;">${TERMS_TEXT}</div>`;
    }

    if (service.label === "Салбарын мэдээл" && branch.length > 0) {
      return branch
        .map(
          (b) => `
        <div style="margin-bottom:16px; padding:12px; border:1px solid #ddd; border-radius:8px;">
          <p><strong>${b.name}</strong></p>
          <p>${b.location || ""}</p>
          ${
            b.link
              ? `<p><a href="${b.link}" target="_blank" style="color:#1D4ED8;">${b.link}</a></p>`
              : ""
          }
        </div>
      `
        )
        .join("");
    }

    if (service.label === "Үнийн мэдээлэл" && price.length > 0) {
      return priceMap[price[0].id] || service.description;
    }

    if (service.label === "Хүргэлт" && delivery.length > 0) {
      return deliveryMap[delivery[0].id] || service.description;
    }

    if (service.label === "Заавар сургалт" && training.length > 0) {
      return training
        .map(
          (t) => `
        <div style="margin-bottom:16px; padding:12px; border:1px solid #ddd; border-radius:8px; background:#fafafa;">
          <p style="margin:0 0 6px 0; font-weight:600; color:#111827;">
            ${t.name || "Нэр байхгүй"}
          </p>
          ${
            t.link
              ? `<a href="${t.link}" target="_blank" style="color:#1D4ED8;">Сургалтын линк рүү очих</a>`
              : `<span style="color:#6B7280;">Мэдээлэл байхгүй</span>`
          }
        </div>
      `
        )
        .join("");
    }

    if (service.label === "Хаяг холбох" && connect.length > 0) {
      return connect
        .map(
          (c) => `
      <div
        style="
          margin-bottom:18px;
          padding:12px;
          border:1px solid #d1d5db;
          border-radius:10px;
          background:#fafafa;
        "
      >
        <div style="display:flex; justify-content:space-between; align-items:center; margin-bottom:12px;">
          <p style="margin:0; font-weight:600; font-size:16px;">${c.name}</p>
          <button onclick="navigator.clipboard.writeText('${c.name}').then(() => alert('Амжилттай хууллаа'))" 
            style="padding:4px 10px; background:#1d4ed8; color:white; border-radius:5px; border:none; font-size:12px;">
            Хуулах
          </button>
        </div>

        <div style="display:flex; justify-content:space-between; align-items:center; margin-bottom:12px;">
          <p style="margin:0; font-weight:600;">Хаяг:</p>
          <p style="margin:0; flex:1; padding-left:10px;">${c.location}</p>
          <button onclick="navigator.clipboard.writeText('${c.location}').then(() => alert('Амжилттай хууллаа'))" 
            style="padding:4px 10px; background:#1d4ed8; color:white; border-radius:5px; border:none; font-size:12px;">
            Хуулах
          </button>
        </div>

        <div style="display:flex; justify-content:space-between; align-items:center; margin-bottom:12px;">
          <p style="margin:0; font-weight:600;">Утас:</p>
          <p style="margin:0; padding-left:10px;">${c.phone}</p>
          <button onclick="navigator.clipboard.writeText('${c.phone}').then(() => alert('Амжилттай хууллаа'))" 
            style="padding:4px 10px; background:#1d4ed8; color:white; border-radius:5px; border:none; font-size:12px;">
            Хуулах
          </button>
        </div>

        ${
          c.price
            ? `
          <div style="display:flex; justify-content:space-between; align-items:center;">
            <p style="margin:0; font-weight:600;">Бүс нутаг:</p>
            <p style="margin:0; padding-left:10px;">${c.price}</p>
            <button onclick="navigator.clipboard.writeText('${c.price}').then(() => alert('Амжилттай хууллаа'))"  
              style="padding:4px 10px; background:#1d4ed8; color:white; border-radius:5px; border:none; font-size:12px;">
              Хуулах
            </button>
          </div>
        `
            : ""
        }
      </div>
    `
        )
        .join("");
    }

    return service.description;
  };

  // ---------------- UI ----------------
  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-800 mb-12">
          Манай үйлчилгээ
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-6 max-w-6xl mx-auto">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <div
                key={service.label}
                onClick={() => handleOpen(index)}
                className="group bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-transform transform hover:-translate-y-2 cursor-pointer border border-gray-200 flex flex-col items-center"
              >
                <div className="w-16 h-16 rounded-xl flex items-center justify-center mb-4  group-hover:bg-blue-600 transition-colors">
                  <ServiceIcon src={service.img} Icon={Icon} />
                </div>
                <p className="text-sm font-medium text-center text-gray-800 group-hover:text-blue-600 transition-colors">
                  {service.label}
                </p>
              </div>
            );
          })}
        </div>
      </div>

      {openIndex !== null && (
        <Dialog open onClose={handleClose} fullWidth maxWidth="sm">
          <DialogTitle className="flex justify-between items-center">
            <span className="font-bold">{services[openIndex].label}</span>
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <div
              className="text-sm"
              dangerouslySetInnerHTML={{
                __html: getDescriptionHtml(services[openIndex]),
              }}
            />
          </DialogContent>
        </Dialog>
      )}
    </section>
  );
};

export default ServicesSection;
